import request from 'supertest'
import { app } from '@/infra/app'
import { prismaService as prisma } from '@/infra/database/prisma'
import { OriginFactory } from 'test/factories/makeOrigin'

describe('Create Lead (E2E)', () => {
  let originFactory: OriginFactory
  beforeEach(async () => {
    originFactory = new OriginFactory(prisma)
  })
  test('[POST] /leads', async () => {
    await originFactory.makePrismaOrigin({
      name: 'Test e2e'
    })

    const response = await request(app)
    .post('/leads')
    .set('Authorization', `Bearer F5D9`)
    .send({
      name: 'test e2e',
      email: 'test.e2e@test.com',
      phone: '11999009900',
      originName: 'Test e2e'
    })

    expect(response.status).toBe(201)
    const leadsCount = await prisma.lead.count()

    expect(leadsCount).toEqual(1)
  }, 10000)
  afterEach(async () => {
    await prisma.lead.deleteMany()
    await prisma.origin.deleteMany()
  })
})